import { customAxios } from './customAxios'
export function getPraticheDettaglio(codiceFiscale) {
    const config = {
        params: { codiceFiscale: codiceFiscale.toString() },
        headers: {
            Accept: "*/*",
            'AuthToken': JSON.parse(localStorage.getItem('token'))
        },
    }
    const getPraticheDettaglioRequest =  customAxios.get(process.env.REACT_APP_BACKEND_HOST + `/`+process.env.REACT_APP_PATH_NEW_PREFIX+`/getPraticheDettaglioByCf?`, config).then(response => response.data.body)
    return getPraticheDettaglioRequest
}

